import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F902 {
  f902_01: string;        // 職稱代碼 (PK, 4碼)
  f902_11: string;        // 職稱名稱
  f902_12: string;        // 職稱內容
  f902_91: string;        // 建立者
  f902_92: string | null; // 建立日期
  f902_93: string;        // 修改者
}

export interface CreateRequest {
  f902_01: string;
  f902_11: string;
  f902_12: string;
}

export interface UpdateRequest {
  f902_11: string;
  f902_12: string;
}

export interface ListResponse {
  data: F902[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const jobTitleApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/job-title', { params });
    return res.data;
  },

  async get(code: string): Promise<F902> {
    const res = await apiClient.get(`/api/job-title/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F902> {
    const res = await apiClient.post('/api/job-title', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F902> {
    const res = await apiClient.put(`/api/job-title/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/job-title/${encodeURIComponent(code)}`);
  },
};
